import { lazy } from 'react';
const AdminHome = lazy(() => import('@/pages/AdminHome'));
const IconsTable = lazy(() => import('@/pages/Icons Module/Home'));
const UshersTable = lazy(() => import('@/pages/Ushers Module/Home'));
const EventsTable = lazy(() => import('@/pages/Events Module/Home'));
const EventForm = lazy(() => import('@/pages/Events Module/EventForm'));
const SessionTable = lazy(() => import('@/pages/Events Module/sessions/SessionTable'));
const FieldsForm = lazy(() => import('@/pages/Events Module/fields/Home'));
const EditForm = lazy(() => import('@/pages/Events Module/EditForm'));
const Profile = lazy(() => import('@/pages/Profile'));
const EvenAdminShow = lazy(() => import('@/pages/Events Module/EvenAdminShow'));
const SessionView = lazy(() => import('@/pages/SessionView'));
const AdminsTable = lazy(() => import('@/pages/Admins Module/Home'));
const Login = lazy(() => import('@/pages/Login'));
const UsherHome = lazy(() => import('@/pages/UsherHome'));
const EventViewForUsher = lazy(() => import('@/pages/Events Module/EventViewForUsher'));
const AttendeeRegistration = lazy(() => import('@/pages/Attendee/AttendeeRegistration'));
const AttendeeHomePage = lazy(() => import('@/pages/Attendee/AttendeeHomePage'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const PartnersTable = lazy(() => import('@/pages/Partner Module/Home'));
const PartnerDetails = lazy(() => import('@/pages/Partner Module/PartnerDetails'));
const RegisterHome = lazy(() => import('@/pages/RegisterModule/Home'));
const SurveyHome = lazy(() => import('@/pages/Events Module/survey/Home'));
const QuestionForm = lazy(() => import('@/pages/Events Module/survey/QuestionForm'));
const SurveyAnswerForm = lazy(() => import('@/pages/Events Module/survey/SurveyAnswerForm'));
const MailsStatus = lazy(() => import('@/pages/Events Module/mails/Home'));
export {
	AdminHome,
	IconsTable,
	UshersTable,
	EventsTable,
	EventForm,
	SessionTable,
	FieldsForm,
	EditForm,
	Profile,
	EvenAdminShow,
	SessionView,
	AdminsTable,
	Login,
	UsherHome,
	EventViewForUsher,
	AttendeeRegistration,
	AttendeeHomePage,
	NotFound,
	PartnersTable,
	RegisterHome,
	PartnerDetails,
	SurveyHome,
	QuestionForm,
	SurveyAnswerForm,
	MailsStatus,
};
